import React from "react";
import { errorToast } from "../../Common/showtoast";

function Employment({ stateObj, setStateObj, UpdateProfile, setCurrentDiv }) {
  return (
    <div className="row">
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label htmlFor="employmentstatus" className="form-label">
            Are you a Startup / Fresher?
          </label>
          <select
            className="form-control"
            name="employment"
            id="employmentstatus"
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                employmentstatus: e.target.value,
              })
            }
            value={stateObj.employmentstatus}
          >
            <option value=""> -- Select -- </option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="totalexperience">
            Total Work Experience in Business / Marketing:
          </label>
          <input
            type="text"
            className="form-control"
            id="totalexperience"
            name="totalexperience"
            onChange={(e) =>
              setStateObj({
                ...stateObj,
                totalexperience: e.target.value,
              })
            }
            value={stateObj.totalexperience}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="companyname">
            Nature of work:
            <small style={{ float: "right" }}>
              {stateObj.companyname?.length || 0} / 1000
            </small>
          </label>
          <input
            className="form-control"
            type="text"
            id="companyname"
            name="companyname"
            onChange={(e) => {
              if (e.target.value.length <= 1000)
                setStateObj({ ...stateObj, companyname: e.target.value });
            }}
            value={stateObj.companyname}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="industry">
            Industry:
          </label>
          <input
            className="form-control"
            type="text"
            id="industry"
            onChange={(e) =>
              setStateObj({ ...stateObj, industry: e.target.value })
            }
            value={stateObj.industry}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label" htmlFor="jobtitle">
            Designation / Profession:
          </label>
          <input
            className="form-control"
            type="text"
            onChange={(e) =>
              setStateObj({ ...stateObj, jobtitle: e.target.value })
            }
            value={stateObj.jobtitle}
          />
        </div>
      </div>
      {/* <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label htmlFor="currentcity">Current City:</label>
          <input
            className="form-control"
            type="text"
            name="currentcity"
            id="currentcity"
            onChange={(e) =>
              setStateObj({ ...stateObj, currentcity: e.target.value })
            }
            value={stateObj.currentcity}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label htmlFor="duration">Duration:</label>
          <input
            className="form-control"
            type="text"
            name="duration"
            id="duration"
            onChange={(e) =>
              setStateObj({ ...stateObj, duration: e.target.value })
            }
            value={stateObj.duration}
          />
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label htmlFor="noticeperiod">Notice Period:</label>
          <input
            className="form-control"
            type="text"
            name="noticeperiod"
            id="noticeperiod"
            onChange={(e) =>
              setStateObj({ ...stateObj, noticeperiod: e.target.value })
            }
            value={stateObj.noticeperiod}
          />
        </div>
      </div> */}
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            About Yourself:
            <small style={{ float: "right" }}>
              {stateObj.description?.length || 0} / 2000
            </small>
          </label>
          <textarea
            className="form-control"
            placeholder="Brief introduction"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (e.target.value.length <= 2000)
                setStateObj({ ...stateObj, description: e.target.value });
            }}
            value={stateObj.description}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            Core Values / Philosophy:
            <small style={{ float: "right" }}>
              {stateObj.philosophy?.length || 0} / 250
            </small>
          </label>
          <textarea
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Core Values  / Philosophy"
            }
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, philosophy: e.target.value });
            }}
            value={stateObj.philosophy}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            Specialisation / Expertise :
            <small style={{ float: "right" }}>
              {stateObj.skills?.length || 0} / 250
            </small>
          </label>
          <textarea
            placeholder={"Enter your specialisation separeted with comma"}
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (e.target.value.length <= 250)
                setStateObj({ ...stateObj, skills: e.target.value });
            }}
            value={stateObj.skills}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            Tools Used :
            <small style={{ float: "right" }}>
              {stateObj.tools?.length || 0} / 250
            </small>
          </label>
          <textarea
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Tools you have used separated with comma"
            }
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, tools: e.target.value });
            }}
            value={stateObj.tools}
          ></textarea>
        </div>
      </div>
      <div className="col-sm-6 col-md-6">
        <div className="form-group">
          <label className="form-label w-100" htmlFor="linkedin">
            Additional Skills:
            <small style={{ float: "right" }}>
              {stateObj.additionalskills?.length || 0} / 250
            </small>
          </label>
          <textarea
            placeholder={
              stateObj.activestatus !== "True"
                ? "Subscribe To Enter"
                : "Additional skills separated with comma"
            }
            readOnly={stateObj.activestatus !== "True"}
            className="form-control"
            style={{ minHeight: 100 }}
            onChange={(e) => {
              if (
                e.target.value.length <= 250 &&
                stateObj.activestatus === "True"
              )
                setStateObj({ ...stateObj, additionalskills: e.target.value });
            }}
            value={stateObj.additionalskills}
          ></textarea>
        </div>
      </div>
      <div className="form-group">
        <button
          className="btn btn-primary "
          onClick={() => {
            if (!stateObj.industry) {
              return errorToast("Enter valid industry");
            }
            UpdateProfile();
            setCurrentDiv("contact");
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default Employment;
